import e from "./Sonner_vue.js";
//#region src/components/ui/sonner/Sonner.vue
var t = e;
//#endregion
export { t as default };

//# sourceMappingURL=Sonner.js.map